import { fabric } from 'fabric';
import Interactive from '../../canvases/interactive';

export class GroupAlignment {
  canvas!: fabric.Canvas;
  manager!: Interactive;

  init(manager: Interactive) {
    this.canvas = manager.canvas;
    this.manager = manager;
  }

  left = () => {
    const activeObjects = this.canvas.getActiveObjects();
    if (activeObjects[0].left === undefined) return;

    const minLeft = activeObjects.reduce((minLeft: number, object) => {
      if (object.left === undefined) return minLeft;
      if (object.left < minLeft) minLeft = object.left;
      return minLeft;
    }, activeObjects[0].left);

    activeObjects.forEach((object) => {
      object.set({ left: minLeft });
    });

    this.manager.reselectActiveObjects();
  };

  right = () => {
    const activeObjects = this.canvas.getActiveObjects();
    if (!activeObjects.length || activeObjects[0]?.left === undefined || activeObjects[0]?.width === undefined) return;

    const maxRight = activeObjects.reduce((maxRight: number, object) => {
      if (object?.left === undefined || object?.width === undefined) return maxRight;
      const left = object.getBoundingRect(true).left;
      const width = object.getBoundingRect(true).width;
      const objectRight = left + width;
      return Math.max(maxRight, objectRight);
    }, -Infinity);

    activeObjects.forEach((object) => {
      if (object?.width === undefined) return;
      if (object.top === undefined) return;
      object.setPositionByOrigin(new fabric.Point(maxRight, object.top), 'right', 'top');
      object.setCoords();
    });

    this.canvas.requestRenderAll();
    this.manager.reselectActiveObjects();
  };

  top = () => {
    const activeObjects = this.canvas.getActiveObjects();
    if (activeObjects[0].top === undefined) return;

    const minTop = activeObjects.reduce((minTop: number, object) => {
      if (object.top === undefined) return minTop;
      if (object.top < minTop) minTop = object.top;
      return minTop;
    }, activeObjects[0].top);

    activeObjects.forEach((object) => {
      object.set({ top: minTop });
    });

    this.manager.reselectActiveObjects();
  };

  bottom = () => {
    const activeObjects = this.canvas.getActiveObjects();
    if (!activeObjects.length || activeObjects[0]?.top === undefined) return;

    const maxBottom = activeObjects.reduce((maxBottom: number, object) => {
      if (object?.top === undefined) return maxBottom;
      const top = object.getBoundingRect(true).top;
      const height = object.getBoundingRect(true).height;
      const objectBottom = top + height;
      return Math.max(maxBottom, objectBottom);
    }, -Infinity);

    activeObjects.forEach((object) => {
      if (object?.top === undefined || object?.left === undefined) return;
      object.setPositionByOrigin(new fabric.Point(object.left, maxBottom), 'left', 'bottom');
      object.setCoords();
    });

    this.canvas.requestRenderAll();
    this.manager.reselectActiveObjects();
  };

  centerVertical = () => {
    this.manager.reselectActiveObjects();

    const activeObject = this.canvas.getActiveObject();
    const width = this.manager.resolution.value.width;
    if (!activeObject || !width || !activeObject.width) return;
    activeObject.set({
      left: width / 2 - activeObject.width / 2,
    });

    this.canvas.requestRenderAll();
  };

  centerHorizontal = () => {
    this.manager.reselectActiveObjects();

    const activeObject = this.canvas.getActiveObject();
    const height = this.manager.resolution.value.height;
    if (!activeObject || !height || !activeObject.height) return;
    activeObject.set({
      top: height / 2 - activeObject.height / 2,
    });

    this.canvas.requestRenderAll();
  };
}

const groupAlignment = new GroupAlignment();
export default groupAlignment;
